/**
 * Story `be-fe-contactgegevens-bevestigen` (AC 5/7) — het window-event bij een 403 `contact_verification_required`
 * van welke call ook. `apiClient` vuurt hem, de `AuthProvider` luistert erop en zet het whoami-veld aan.
 *
 * Een eigen module zonder imports: zowel `apiClient` als `contactVerification` (dat `apiClient` importeert) lezen
 * hem, zonder kring en zonder dat een test die `apiClient` mockt hem kwijtraakt.
 */
export const CONTACT_VERIFICATION_REQUIRED_EVENT = 'carculate:contact-verification-required';
